export default __webpack_public_path__ + "static/media/1893.86fb5563.png";